import type { Aggregation } from '~/modules/GraphQL/types';

export function sortFiltersByAttributeCode(filters: Aggregation[], sortedCodes: string[]): Aggregation[] {
  return [...filters].sort((a, b) => {
    const aIndex = sortedCodes.indexOf(a.attribute_code);
    const bIndex = sortedCodes.indexOf(b.attribute_code);
    if (aIndex === -1 && bIndex === -1) {
      return 0;
    }
    if (aIndex === -1) {
      return 1;
    }
    if (bIndex === -1) {
      return -1;
    }
    return aIndex - bIndex;
  });
}
